import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { ASDocument } from '../document';
import { MDOCUMENTS } from '../results/mock-document';

@Injectable()
export class DocumentViewerService {
    getDocuments(): ASDocument[] {
        return MDOCUMENTS;
    }

   /* private documentViewerUrl = 'document_list_test'; //URL to web api
    constructor(private http: Http) { }
    getDocuments(): Promise<Document[]> {
        return this.http.get(this.documentViewerUrl)
            .toPromise()
            .then(response => response.json().data as Document[])
            .catch(this.handleError);
    }*/
   
    getDocument(id: number): ASDocument {
        let asdocuments = this.getDocuments();
        return asdocuments.find(asdocument => asdocument.id === id);
    }
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}